<template>
  <span class="indicator"></span>
</template>

<style scoped>
@layer {
  .indicator {
    width: 1em;
  }
}
.indicator {
  display: inline-grid;
  aspect-ratio: 1;
}
.indicator::before,
.indicator::after {
  content: '';
  grid-row: 1;
  grid-column: 1;
  border-width: 0.2em;
  border-color: var(--glp-busy-indicator-color, currentColor);
  border-radius: 50%;
}
.indicator::before {
  opacity: 0.3;
}
.indicator::after {
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  animation: busy 1s infinite cubic-bezier(0.7, 0.2, 0.5, 0.9);
}
@keyframes busy {
  from {
    rotate: 0turn;
  }
  to {
    rotate: 1turn;
  }
}
</style>
